module.exports = __webpack_public_path__ + "img/qa.b06cc584.svg";